import React from 'react'
import TextField from '@material-ui/core/TextField'
import WaringIcon from '@material-ui/icons/Warning'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormHelperText from '@material-ui/core/FormHelperText'
import AutoComplete from 'material-ui/AutoComplete';
import Snackbar from '@material-ui/core/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { fetchBuList, getVendors, validateGSTN } from '../utils/PaymentRequestApiUtils'
import { data } from '../component-data/paymentrequest-data/PaymentRequest'
import userdata from '../config/jwt_token'
import { Dialog, DialogContent } from '@material-ui/core'
import { billTypeList } from '../constants/billTypeList'
const errorText = 'This field is required'
class PaymentDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data : {
        ...data,
        mode_of_payment: 'Online Payment'
      },
      type_of_payments: ['Advance Against PO', 'Final Settlement'],
      type_of_paymentErr: false,
      type_of_paymentErrText: '',
      vendors: [],
      vendor_nameErr: false,
      vendor_nameErrText: '',
      gstn_statusErr: false,
      gstn_statusErrText: '',
      value: '',
      status: this.props.data.status || true,
      snackText: '',
      snackOpen: false,
      editData: {},
      index: undefined,
      vendorWaringModal: false,
      vendorErrorObj: {
        flag: false,
        errors: []
      },
      buList: []
    }
  }
  componentDidMount(props) {
    if (this.props.data.paymentDetails !== undefined) {
      this.setState({
        data: this.props.data.paymentDetails,
        searchText: `${this.props.data.paymentDetails.vendor_name}(${this.props.data.paymentDetails.vendor_code})`,
        status: this.props.data.status
      }, () => this.isVendorError())
    }
    let selected_city = localStorage.getItem('selected_city')
    if((!selected_city) && userdata.city.length > 0) {
      selected_city = userdata.city[0].city_name
      localStorage.setItem('selected_city', selected_city)
    }
    getVendors(selected_city).then((response) => {
      if (response) {
        if (response.status === 'success')
          this.setState({ vendors: response.data }, () => this.isVendorError())
      }
    })
    fetchBuList().then((response) => {
      if (response) {
        if (response.status === 'success') {
          const tempBuList = response.data;
          // Add Scholar to the list if status is edit to maintain old data and new data(which got replaced with Elevate)
          if(this.state.status === 'edit') {
            tempBuList.push({ label: 'Scholar', value: 'scholar' });
          }
          this.setState({ buList: tempBuList })
        }
      }
    })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data.paymentDetails !== undefined) {
      this.setState({
        data: nextProps.data.paymentDetails,
        searchText: `${nextProps.data.paymentDetails.vendor_name}(${nextProps.data.paymentDetails.vendor_code})`,
        status: nextProps.data.status,
        prevPath: nextProps.data.paymentDetails.prevPath
      }, () => this.isVendorError())
    }
  }
  handleChange = (props) => (event, index, value) => {
    if (props === 'bank_acc_number') {
      let myregex = /^[A-Za-z0-9]{0,18}$/
      if (!myregex.test(event.target.value)) {
        this.setState({ snackText: 'Invalid Bank Account number', snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value } })
      }
    }
    else if (props === 'ifsc_code') {
      let myRegxp = /^([a-zA-Z0-9_-]){0,11}$/
      if (!myRegxp.test(event.target.value)) {
        this.setState({ snackText: "IFSC length should be 11 characters", snackOpen: true })
        return
      }
      else {
        this.setState({ data: { ...this.state.data, [props]: event.target.value } })
      }
    }
    else if (props === 'vendor_name') {
      this.props.removeTdsRateCheck();
      this.setState({
        data: {
          ...this.state.data, 
          [props]: event.value.name, 
          vendor_code: event.value.vendor_code,
          beneficiary_name: event.value.beneficiary_name, 
          vendor_id: event.value.vendor_buffer_id,
          bank_acc_number: event.value.bank_acc_number, 
          ifsc_code: event.value.ifsc_code, 
          bank_name: event.value.bank_name, 
          tds_rate: event.value.tds_rate,
          vendor_deactivate: event.value.vendor_deactivate,
          agreement_expiry_date: event.value.agreement_expiry_date ? new Date(event.value.agreement_expiry_date) : null,
          defaultor_amount: event.value.defaultor_amount,
          pancard_status: event.value.pancard_status,
          gstn_status: event.value.gstn_status,
          vendor_ldc_data: event.value.vendor_ldc_data ? JSON.parse(event.value.vendor_ldc_data) : null,
          gstn: event.value.gstn
        },
        [props + 'ErrText']: '', [props + 'Err']: false
      }, () => this.isVendorError())
    }
    else if (props === 'type_of_payment'){
        let type = event.target.value;
        this.setState({data:
            {
                ...this.state.data, type_of_payment: type
            }
        },
        () => this.props.getPaymentType(type))
    }
    else {
      this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
  }

  handleEdit(value) {
    this.setState({ editData: this.state.data[value], status: false, index: value })
  }

  async handleNext() {
    if (this.state.data.business_unit === '') {
      this.setState({ business_unitErrText: errorText, business_unitErr: true })
    }
    if (this.state.data.bill_type === '') {
      this.setState({ bill_typeErrText: errorText, bill_typeErr: true })
    }
    if (this.state.data.vendor_name === '') {
      this.setState({ vendor_nameErrText: errorText, vendor_nameErr: true })
    }
    if (this.state.data.type_of_payment === '') {
      this.setState({ type_of_paymentErrText: errorText, type_of_paymentErr: true })
    }
    if (this.state.data.bank_acc_number !== '') {
        let myregex = /^[A-Za-z0-9]{6,18}$/
        if (!myregex.test(this.state.data.bank_acc_number)) {
          this.setState({ snackText: 'Invalid Bank Account number', snackOpen: true })
          return
        }
      }
    if (this.state.data.ifsc_code !== '') {
    let myRegxp = /^([a-zA-Z0-9_-]){11}$/;
        if (!myRegxp.test(this.state.data.ifsc_code)) {
            this.setState({ snackText: "IFSC length should be 11 characters", snackOpen: true })
            return
        }
    }

    if (this.state.data.vendor_code && (this.state.data.gstn || this.state.data.gstn == '')) {
      const gstStatus = await validateGSTN(this.state.data.vendor_code, this.state.data.gstn);
      if (
        gstStatus.flag &&
        !(gstStatus.data[0].gstn_status === "CANCELLED" ||
          gstStatus.data[0].gstn_status === "SUSPENDED")
      ) {
        if (this.state.data.vendor_name !== '' && this.state.data.type_of_payment !== '' && (this.state.data.gstn_status != "SUSPENDED" && this.state.data.gstn_status != "CANCELLED")) {
         this.props.handleNext(this.state.data)  // we are not validating any thing here.
       }
      }
      else {
        this.setState({ snackText: gstStatus.message, snackOpen: true, gstn_statusErr: true, gstn_statusErrText: 'GST Status should be Active' })
      }
    }
    
  }
  
  handleClear() {
    this.props.removeTdsRateCheck();
    this.setState({
      data,
      searchText: '',
      type_of_paymentErr: false,
      type_of_paymentErrText: '',
      type_of_payment: '',
      vendor_nameErr: false,
      vendor_nameErrText: '',
      gstn_statusErr: false,
      gstn_statusErrText: '',
      value: '',
      status: true,
      snackText: '',
      snackOpen: false,
    }, () => this.isVendorError())
    this.props.handleClear()
  }

  handleDetails(value) {

    let data = this.state.data === undefined ? [] : this.state.data
    if (value.status === 'new') {
      data.push(value)
    }
    else {
      data[this.state.index] = value
    }
    this.setState({ status: true, data })
  }

  handleDelete(value) {
    let data = this.state.data.filter((data, index) => index !== value)
    this.setState({ data })
  }

  handleUpdateInput = (searchText) => {
    if(searchText !== '' && searchText !== undefined)
      this.setState({
        searchText: searchText,
      });
    else
    this.setState({
      data: {
        ...this.state.data, vendor_name: '', vendor_code: '',
        beneficiary_name: '', vendor_id: '',
        bank_acc_number: '', ifsc_code: '', bank_name: '',
        gstn: ''
      },
      searchText: searchText,
    });
  };
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }

  handleClose = () => {
    this.setState({ vendorWaringModal: false })
  }

  isVendorError = () => {
    if(!this.state.data) return;
    const errorObj = {
      flag: false,
      errors: []
    };

    if(this.state.data.vendor_deactivate) {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'Vendor Deactivated',
        message: 'Vendor is deactivated',
        renderVal: (
          <span>Yes</span>
        )
      });
    }

    if(this.state.data.agreement_expiry_date) {
      const agreementExpiryDate = new Date(this.state.data.agreement_expiry_date);
      agreementExpiryDate.setHours(0, 0, 0, 0); // Set time to 0
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Set time to 0

      // Check if agreement only expiry date is less than current date and if yes, then show error
      if (agreementExpiryDate < currentDate) {
        errorObj.flag = true;
        errorObj.errors.push({
          name: 'Vendor Agreement Expired On',
          message: 'Agreement expired',
          renderVal: (
            <span>{agreementExpiryDate.toDateString()}</span>
          )
        });
      }
    };

    if(this.state.data.defaultor_amount > 0) {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'Vendor Defaulted Amount',
        message: 'Vendor has defaulted amount',
        renderVal: (
          <span>{this.state.data.defaultor_amount}</span>
        )
      })
    }

    if (this.state.data && this.state.data.vendor_ldc_data && this.state.data.vendor_ldc_data.length > 0) {
      for (let vendorLdcData of this.state.data.vendor_ldc_data) {
        if (vendorLdcData.ldc_amount_limit > 0) {
          errorObj.flag = true;
          errorObj.errors.push({
            name: vendorLdcData.section_name,
            message: 'Vendor has LDC amount limit',
            renderVal: (
              <div>
                <span>{`LDC Limit: \u20B9 ${vendorLdcData.ldc_amount_limit}`}</span><br/>
                <span>LDC Rate: {vendorLdcData.ldc_rate}</span>
              </div>
            )
          })
        }
      }
    }

    if (this.state.data.pancard_status == '0') {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'Pancard Status',
        message: 'Pancard Inoperative',
        renderVal: (
          <span>{"Inoperative"}</span>
        )
      });
    }

    if (this.state.data.gstn_status == 'SUSPENDED' || this.state.data.gstn_status == 'CANCELLED') {
      errorObj.flag = true; 
      errorObj.errors.push({
        name: 'GST Status',
        message: 'GST Status is not Active',
        renderVal: (
          <span>{this.state.data.gstn_status}</span>
        )
      });
    }

    this.setState({ vendorErrorObj: errorObj });
  }

  render() {
    return (
      <MuiThemeProvider >
        <div>
          <div style={{ position: 'relative' }}>
            <AutoComplete
              hintText="Vendor"
              errorText={this.state.vendor_nameErrText ? this.state.vendor_nameErrText : this.state.gstn_statusErrText}
              errorStyle={{ fontSize: '12px', color: 'red' }}
              floatingLabelText='*Vendor Name'
              searchText={this.state.searchText}
              onUpdateInput={this.handleUpdateInput}
              onNewRequest={this.handleChange('vendor_name')}
              dataSource={this.state.vendors.map((val, index) => {
                let vendorDescription = val.name + ' (' + val.vendor_code + ') - '+ val.city_name;
                if(val.national)
                  vendorDescription = vendorDescription + ' - National Vendor';
                return {
                  text: vendorDescription,
                  value: (
                    val
                  )
                }
              })}
              filter={AutoComplete.caseInsensitiveFilter}
              openOnFocus={true}
              textFieldStyle={{ width: '620px' }}
              listStyle={{ width: '620px', maxHeight: 200, overflow: 'auto'  }}
              underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
              floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              disabled={this.state.status == 'edit'}
            />
            {this.state.vendorErrorObj.flag && (
              <WaringIcon 
                style={{ 
                  color: '#FF0000',
                  position: 'absolute', 
                  right: '-1.7rem', 
                  bottom: '1rem',
                  cursor: 'pointer'
                }} 
                onClick={() => this.setState({ vendorWaringModal: true })}
              />
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <TextField
              label="Beneficiary Name"
              placeholder=" Enter Beneficiary Name"
              margin='normal'
              disabled
              value={this.state.data.beneficiary_name}
              onChange={this.handleChange('beneficiary_name')}
              style={{ width: '300px' }}
              helperText={this.state.beneficiary_nameErrText}
              error={this.state.beneficiary_nameErr}
            />
            <TextField
              label="Bank Account Number"
              placeholder=" Enter Account Number"
              disabled
              value={this.state.data.bank_acc_number}
              onChange={this.handleChange('bank_acc_number')}
              margin='normal'
              style={{ width: '300px', marginLeft: '20px' }}
              helperText={this.state.bank_acc_numberErrText}
              error={this.state.bank_acc_numberErr}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <TextField
              label="IFSC Code"
              placeholder=" Enter IFSC Code"
              disabled
              value={this.state.data.ifsc_code}
              onChange={this.handleChange('ifsc_code')}
              style={{ width: '300px' }}
              margin='normal'
              helperText={this.state.ifsc_codeErrText}
              error={this.state.ifsc_codeErr}
            />
            <TextField
              label="Bank Name"
              placeholder=" Enter Bank Name"
              value={this.state.data.bank_name}
              disabled
              onChange={this.handleChange('bank_name')}
              margin='normal'
              style={{ width: '300px', marginLeft: '20px' }}
              helperText={this.state.bank_nameErrText}
              error={this.state.bank_nameErr}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '16px' }}>
              <InputLabel htmlFor="business_unit-mode">*Select Business Unit</InputLabel>
              <Select
                value={this.state.data.business_unit}
                onChange={this.handleChange('business_unit')}
                style={{ width: '300px' }}
                helperText={this.state.business_unitErrText}
                error={this.state.business_unitErr}
                disabled={this.state.status==='edit'}
              >
                {
                  this.state.buList.map(bu => {
                    return <MenuItem value={bu.value}>{bu.label}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.business_unitErrText}</FormHelperText>
            </FormControl>
            <FormControl style={{ marginTop: '16px', marginLeft: '20px' }}>
              <InputLabel htmlFor="bill_type-mode">*Select Bill Type</InputLabel>
              <Select
                value={this.state.data.bill_type}
                onChange={this.handleChange('bill_type')}
                style={{ width: '300px' }}
                helperText={this.state.bill_typeErrText}
                error={this.state.bill_typeErr}
                disabled={this.state.status==='edit'}
              >
                {
                  billTypeList.map(item => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.bill_typeErrText}</FormHelperText>
            </FormControl>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '16px' }}>
              <InputLabel htmlFor="type_of_payment-mode">*Type of payment</InputLabel>
              <Select
                value={this.state.data.type_of_payment}
                onChange={this.handleChange('type_of_payment')}
                style={{ width: '300px', textAlign: 'left' }}
                helperText={this.state.payment_modeErrText}
                error={this.state.type_of_paymentErr}
                disabled={this.state.status==='edit'}
              >
                {
                  this.state.type_of_payments.map(payment_mode => {
                    return <MenuItem value={payment_mode}>{payment_mode}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red' }}>{this.state.type_of_paymentErrText}</FormHelperText>
            </FormControl>
            <TextField
              label="Vendor GSTN"
              placeholder=" Enter Vendor GSTN"
              disabled
              value={`${this.state.data.gstn} ${this.state.data.gstn_status ? `(${this.state.data.gstn_status})` : ''}`}
              onChange={this.handleChange('gstn')}
              style={{ width: '300px', marginLeft: '20px' }}
              margin='normal'
              helperText={this.state.gstnErrText}
              error={this.state.gstnErr}
            />
          </div>
          <div className="zaps-form-actions">

            <RaisedButton
              label="Clear"
              primary={true}
              onClick={this.handleClear.bind(this)}
              buttonStyle={{ backgroundColor: 'red' }}
            />
            <RaisedButton style={{ marginLeft: '20px' }} label={`Next`} primary={true} onClick={this.handleNext.bind(this)} />
          </div>
        </div>
        <Dialog
          open={this.state.vendorWaringModal}
          onClose={() => this.handleClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000' }}>
              <List>
                {this.state.vendorErrorObj.errors.map((error, index) => (
                  <ListItem key={error.name}>
                    <ListItemText style={{ minWidth: '240px' }} primary={error.name} />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={error.renderVal} />
                  </ListItem>
                ))}
              </List>
            </div>
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
      </MuiThemeProvider>
    )
  }
}

export default PaymentDetails


// WEBPACK FOOTER //
// ./src/components/PaymentDetails.js